import { connect } from "react-redux";

import { Dispatch } from "redux";
import { LanguageCodes } from "../../constants/languages";
import { Routes } from "../../constants/routes";
import { ApplicationState } from "../../store";
import {
    toggleAbleToSeeAndModifyExistingPatientDataOption,
    toggleAbleToSeeAndModifyExistingPreferredPharmacyOption,
    toggleDisplayProfilePicturesDuringAppointmentConfirmationOption,
    toggleHealthCardExpirationRedirectToReceptionOption,
    toggleRegionCodeConfirmationRequiredOption,
    updateLanguageSelectionList,
    changeDefaultLanguage,
    changeAdminSettingNumberField,
    selectCurrentSite,
    changeAppointmentTimeRangeValue,
    updateSiteSelectionList
} from "../../store/AdminOptions/actions";
import {
    getDisplayProfilePicturesValue,
    getHealthCardExpirationRedirectToReceptionValue,
    getOptionAbleToSeeAndModifyExistingPatientData,
    getOptionAbleToSeeAndModifyExistingPreferredPharmacy,
    getOptionRegionCodeConfirmationRequired,
    getAdminSettingFieldValues
} from "../../store/AdminOptions/selectors";
import { getClinicName, getSitesList } from "../../store/ClinicInformation/selectors";
import { getLanguageCode, getTextLibrary } from "../../store/LanguageLocale/selector";
import { getIsUserAuthenticated } from "../../store/Login/selectors";
import { AdminSetupPage } from "./AdminSetupPage.component";
import { IAdminSetupMapDispatchProps, IAdminSetupMapStateProps } from "./Types";
import { startApplicationAfterSettingAdminOptions, returnToIntroductionScreen } from "../../sagas/ApplicationAsyncSagas/actions";
import { StartApplicationPayload } from "../../sagas/ApplicationAsyncSagas/types";
import TimerManager from "../../services/TimerManager";
import { toggleSnackBarPopupVisibility } from "../../store/SnackBarPopup/actions";
import { push } from "../../store/Routing/actions";

const mapStateToProps = (state: ApplicationState): IAdminSetupMapStateProps => {
    return {
        lang: getLanguageCode(state.localeText),
        textLibrary: getTextLibrary(state.localeText),
        isUserAuthenticated: getIsUserAuthenticated(state.login),
        ableToSeeAndModifyExistingPatientData: getOptionAbleToSeeAndModifyExistingPatientData(state.adminOptions),
        ableToSeeAndModifyExistingPreferredPharmacy: getOptionAbleToSeeAndModifyExistingPreferredPharmacy(state.adminOptions),
        regionCodeConfirmationRequired: getOptionRegionCodeConfirmationRequired(state.adminOptions),
        displayProfilePicture: getDisplayProfilePicturesValue(state.adminOptions),
        healthCardExpiryRedirect: getHealthCardExpirationRedirectToReceptionValue(state.adminOptions),
        clinicSiteName: getClinicName(state.clinicInformation),
        selectedLanguages: state.adminOptions.useableLanguages,
        sitesOptions: getSitesList(state.clinicInformation, state.adminOptions),
        sites: state.clinicInformation.sites,
        currentSelectedSite: state.adminOptions.siteId,
        selectedSites: state.adminOptions.multiSiteIds,
        defaultLanguage: state.adminOptions.defaultLanguage,
        settingValues: getAdminSettingFieldValues(state.adminOptions),
        featureSwitch: state.clinicInformation.featureFlags,
        clinicSettings: state.clinicInformation.myleClinicSettings,
        isLoadingSpinnerActive: state.loadingSpinner.visible
    };
};

const mapDispatchToProps = (dispatch: Dispatch): IAdminSetupMapDispatchProps => ({
    startApplication: (payload: StartApplicationPayload, inactivityDelay: number) =>{
        dispatch(startApplicationAfterSettingAdminOptions(payload)),
        TimerManager.setUpInactivityTimer(
            () => dispatch(returnToIntroductionScreen()),
            () => dispatch(toggleSnackBarPopupVisibility(true)),
            inactivityDelay);
    },

    returnToLoginPage: () => {
        dispatch(push(Routes.root));
    },

    toggleAbleToViewAndModifyPatientInfo: (value: boolean) => {
        dispatch(toggleAbleToSeeAndModifyExistingPatientDataOption(value));
    },

    toggleAbleToViewAndModifyPreferredPharmacy: (value: boolean) => {
        dispatch(toggleAbleToSeeAndModifyExistingPreferredPharmacyOption(value));
    },

    toggleRegionCodeConfirmationRequired: (value: boolean) => {
        dispatch(toggleRegionCodeConfirmationRequiredOption(value));
    },

    toggleDisplayProfilePictures: (value: boolean) => {
        dispatch(toggleDisplayProfilePicturesDuringAppointmentConfirmationOption(value));
    },

    toggleHealthCardExpirationRedirectToReception: (value: boolean) => {
        dispatch(toggleHealthCardExpirationRedirectToReceptionOption(value));
    },

    onLanguageSelectionChange: (checked: boolean, langCode: LanguageCodes) => {
        dispatch(updateLanguageSelectionList(checked, langCode));
    },

    changeDefaultLanguage: (lang: LanguageCodes) => {
        dispatch(changeDefaultLanguage(lang));
    },

    selectCurrentSiteFromList: (currentSiteId: string) => {
        dispatch(selectCurrentSite(currentSiteId));
    },

    onSiteSelectionChange: (checked: boolean, selectedSiteId: string | number) => {
        dispatch(updateSiteSelectionList(checked, selectedSiteId));
    },

    changeAdminSettingNumberField: (field: string, value: number) => {
        dispatch(changeAdminSettingNumberField(field, value));
    },

    changeAppointmentTimeRange: (fieldName: string, value: number) => {
        dispatch(changeAppointmentTimeRangeValue(fieldName, value));
    }
});

export default connect<IAdminSetupMapStateProps, IAdminSetupMapDispatchProps, void>(
    mapStateToProps,
    mapDispatchToProps
)(AdminSetupPage);



// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/AdminSetupPage.container.ts